'use strict';

const ACTION__GET_HEIGHT				= 'getHeight';
const ACTION__GET_HEIGHT_DOCUMENT		= 'documentHeight';
const ACTION__GET_HEIGHT_SCREEN			= 'screenHeight';
const ACTION__GET_HEIGHT_VIEWPORT		= 'vh';

const ACTION__GET_WIDTH					= 'getWidth';
const ACTION__GET_WIDTH_DOCUMENT		= 'documentWidth';
const ACTION__GET_WIDTH_SCREEN			= 'screenWidth';
const ACTION__GET_WIDTH_SCROLLBAR		= 'scrollbarWidth';
const ACTION__GET_WIDTH_VIEWPORT		= 'vw';


const BREAKPOINTS = {
	xs: 480,
	sm: 768,
	md: 1024,
	lg: 1280,
	xl: 1600
};


function get__screen_height(addUnit) {
	if(typeof(addUnit) === 'undefined') {
		return $(window).height();
	}
	return  $(window).height() + 'px';
};
	
function get__screen_width(addUnit) {
	if(typeof(addUnit) === 'undefined') {
		return $(window).width();
	}
	return  $(window).width() + 'px';
};

function get__window_height(addUnit) {
	var height = window.innerHeight || document.documentElement.clientHeight ||document.body.clientHeight;
	if(typeof(addUnit) === 'undefined') {
		return height;
	}
	return height+'px';
};
	
function get__window_width(addUnit) {
	var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	if(typeof(addUnit) === 'undefined') {
		return width;
	}
	return width+'px';
};	


function is__xxs() {
	if(get__window_width() < BREAKPOINTS.xs) {
		console.log('device is xxs');
		return true;
	}
	return false;
};

function is__xs() {
	if(get__window_width() >= BREAKPOINTS.xs && get__window_width() < BREAKPOINTS.sm) {
		console.log('device is xs');
		return true;
	}
	return false;
};

function is__sm() {
	if(get__window_width() >= BREAKPOINTS.sm && get__window_width() < BREAKPOINTS.md) {
		console.log('device is sm');
		return true;
	}
	return false;
};

function is__md() {
	if(get__window_width() >= BREAKPOINTS.md && get__window_width() < BREAKPOINTS.lg) {
		console.log('device is md');
		return true;
	}
	return false;
};

function is__lg() {
	if(get__window_width() >= BREAKPOINTS.lg && get__window_width() < BREAKPOINTS.xl) {
		console.log('device is lg');
		return true;
	}
	return false;
};

function is__xl() {
	if(get__window_width() >= BREAKPOINTS.xl) {
		console.log('device is xl');
		return true;
	}
	return false;
};



function is__mobile() {
		
	var device = {
		Android: function () {
			return navigator.userAgent.match(/Android/i);
		},
		BlackBerry: function () {
			return navigator.userAgent.match(/BlackBerry/i);
		},
		iOS: function () {
			return navigator.userAgent.match(/iPhone|iPod|iPad/i);
		},
		Opera: function () {
			return navigator.userAgent.match(/Opera Mini/i);
		},
		Windows: function () {
			return navigator.userAgent.match(/IEMobile/i);
		}
	};


	if(is__portrait()) {
		console.log('is mobile');
		return true;
	}

	if(device.Android() || device.BlackBerry() || device.iOS() || device.Opera() || device.Windows()) {
		return true;
	}


	if(get__window_width < BREAKPOINTS.md) {
		console.log('is mobile');
		return true;
	}

	return false;
	
};


function is__portrait() {
	
	if(get__window_width() < get__window_height()) {
		return true;
	}
	return false;
		
};


function get__dimension(type) {
		
	switch(type) {
		case ACTION__GET_HEIGHT_DOCUMENT:
			if (typeof document.body.offsetHeight !== 'undefined') {
				return document.body.offsetHeight;
			}
			break;
		case ACTION__GET_HEIGHT_SCREEN:
			if (typeof screen.availHeight !== 'undefined') {
				return  screen.availHeight;
			}
			break;
		case ACTION__GET_HEIGHT_VIEWPORT:
			if (typeof document.documentElement.clientHeight !== 'undefined') {
				return document.documentElement.clientHeight;
			}
			break;
		case ACTION__GET_WIDTH_DOCUMENT:
			if (typeof document.body.offsetWidth !== 'undefined') {
				return document.body.offsetWidth;
			}
			break;
		case ACTION__GET_WIDTH_SCREEN:
			if (typeof screen.availWidth !== 'undefined') {
				return screen.availWidth;
			}
			break;
		case ACTION__GET_WIDTH_SCROLLBAR:
			return scrollbar();
			break;
		case ACTION__GET_WIDTH_VIEWPORT:
			if (typeof document.documentElement.clientWidth !== 'undefined') {
				return document.documentElement.clientWidth;
			}
			break;
		default:;
	} //end of switch

	function scrollbar() {
		var outer = document.createElement("div");
		outer.style.visibility = "hidden";
		outer.style.width = "100px";
		document.body.appendChild(outer);

		var widthNoScroll = outer.offsetWidth;
		// force scrollbars
		outer.style.overflow = "scroll";

		// add inner div
		var inner = document.createElement("div");
		inner.style.width = "100%";
		outer.appendChild(inner);        

		var widthWithScroll = inner.offsetWidth;

		// remove divs
		outer.parentNode.removeChild(outer);

		return widthNoScroll - widthWithScroll;
	}
		
};


export {
	
	ACTION__GET_HEIGHT,
	ACTION__GET_HEIGHT_DOCUMENT,
	ACTION__GET_HEIGHT_SCREEN,
	ACTION__GET_HEIGHT_VIEWPORT,
	ACTION__GET_WIDTH,
	ACTION__GET_WIDTH_DOCUMENT,
	ACTION__GET_WIDTH_SCREEN,
	ACTION__GET_WIDTH_SCROLLBAR,
	ACTION__GET_WIDTH_VIEWPORT,
	BREAKPOINTS,
	get__dimension,
	get__screen_height,
	get__screen_width,
	get__window_height,
	get__window_width,
	is__mobile,
	is__portrait,
	is__xxs,
	is__xs,
	is__sm,
	is__md,
	is__lg,
	is__xl
	
};